export class BoardAction {

    annotations: any[];
    actionType: BoardActionType;
    actionParams: any;
  
    static getInverseActionType(boardActionType: BoardActionType): BoardActionType {
      let inverseActionType = null;
      switch (boardActionType) {
        case BoardActionType.ADD:
          inverseActionType = BoardActionType.DELETE;
          break;
        case BoardActionType.DELETE:
          inverseActionType = BoardActionType.ADD;
          break;
        case BoardActionType.UPDATE:
          inverseActionType = BoardActionType.UPDATE;
          break;
        default:
          break;
      }
      return inverseActionType;
    }
  
    static isValidBoardAction(boardAction: BoardAction): boolean {
      return boardAction && boardAction.actionType && boardAction.annotations && boardAction.annotations.length > 0;
    }
  
    constructor(annotations: any[], boardActionType: BoardActionType, actionParams: any) {
      this.annotations = annotations;
      this.actionType = boardActionType;
      this.actionParams = actionParams;
    }
  }
  
  export enum BoardActionType {
    ADD = 'add',
    DELETE = 'delete',
    UPDATE = 'update'
  }
  